import { RangeControl } from '@wordpress/components';
import { useState,useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';


export function VayuBlocksRangeControl({
    max=10,
    min=0,
    label="Rnage",
    initialPosition=0,
    help="",
    afterIcon="",
    beforeIcon="",
    marks=true,
    step=1,
    withInputField=true,
    attribute={key, value},
    onChange
}){

  const getView = VayuBlocksDevice(); 

// console.log("Range", attribute);
//const [isRangeUnit, setIsRangeUnit] = useState(attribute.key);

const [firstTablet, setfirstTablet] = useState(false);
const [firstDesktop, setfirstDesktop] = useState(false);
const [currentValue, setCurrentValue] = useState(false);


 useEffect(() => {
    if (attribute.key === false) {
        setCurrentValue(attribute.value);
    }else{
        setCurrentValue(attribute.value?.[getView] ?? 0);
    }

}, [attribute.value, getView]);



const handelRangeChange = (value)=>{
    if (attribute.key === false) {
        onChange(value);
    }else{
        handelUnitRangeChange(value);
    }
}


const handelUnitRangeChange = (updateValue) => {
        const attr = attribute.value;
        const key = attribute.key;
        const isFirstRun = attr?.[getView] === undefined;

        if(getView==='Desktop'){

          if (isFirstRun || firstDesktop) {

            onChange(key, { Desktop: updateValue, Tablet: updateValue, Mobile: updateValue });
            setfirstTablet(true);
            setfirstDesktop(true);

        }else{
           onChange(key, { ...attr, Desktop: updateValue });
        }


        }else if(getView==='Tablet'){

              if (firstTablet) {
               onChange(key, { ...attr, Tablet: updateValue, Mobile: updateValue });
                setfirstTablet(true);
                setfirstDesktop(false);

            } else{
                onChange(key, { ...attr, Tablet: updateValue });
            }


      }else if(getView==='Mobile'){

        setfirstTablet(false);
        setfirstDesktop(false);
        onChange(key, { ...attr, Mobile: updateValue });
          }

    };
    
    return(<RangeControl
        __nextHasNoMarginBottom
        help={help}
        initialPosition={initialPosition}
        label={label}
        max={max}
        min={min}
        afterIcon={afterIcon}
        beforeIcon={beforeIcon}
        marks={marks}
        step={step}
        onChange={(value) => handelRangeChange(value,attribute.key)}
        withInputField={withInputField}
        value={ currentValue}
      />)

}